import {Typography, Box} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import React from "react";
import BasicTooltip from "../../../common/BasicTooltip";

export default function InformationTooltip({label}) {
    return(
        <BasicTooltip
            title={
                <Box sx={{minWidth: '250px', maxWidth: '450px', padding: '10px'}}>
                    <Typography sx={{width: '100%', fontSize: '15px', color: '#2C302E'}}>
                        {label}
                    </Typography>
                </Box>
            }
            placement={'bottom'}
            enterDelay={700}
        >
            <InfoIcon sx={{fontSize: '18px'}}/>
        </BasicTooltip>
    )
}